import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faTimes } from '@fortawesome/free-solid-svg-icons';

const UsuarioFilterBar = ({ filters, setFilters, onReset }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleReset = () => {
    const resetFilters = {
      nome: '',
      email: '',
      perfil_id: '',
      ativo: '',
      search: ''
    };
    setFilters(resetFilters);
    if (onReset) onReset();
  };

  return (
    <div className="bg-white rounded shadow p-4 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <FontAwesomeIcon icon={faFilter} className="text-gray-600" />
        <h3 className="text-lg font-semibold text-gray-800">Filtros</h3>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Buscar
          </label>
          <input
            type="text"
            name="search"
            value={filters.search}
            onChange={handleChange}
            placeholder="Nome ou email..."
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Nome
          </label>
          <input
            type="text"
            name="nome"
            value={filters.nome}
            onChange={handleChange}
            placeholder="Nome do usuário"
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Email
          </label>
          <input
            type="email"
            name="email"
            value={filters.email}
            onChange={handleChange}
            placeholder="Email do usuário"
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Perfil
          </label>
          <select
            name="perfil_id"
            value={filters.perfil_id}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          >
            <option value="">Todos os perfis</option>
            <option value="1">Super Admin</option>
            <option value="2">Administrador</option>
            <option value="3">Gerente</option>
            <option value="4">Usuário</option>
            <option value="5">Financeiro</option>
            <option value="6">Acadêmico</option>
          </select>
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Status
          </label>
          <select
            name="ativo"
            value={filters.ativo}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          >
            <option value="">Todos</option>
            <option value="1">Ativo</option>
            <option value="0">Inativo</option>
          </select>
        </div>
        
        <div className="flex items-end">
          <button
            onClick={handleReset}
            className="w-full bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md flex items-center justify-center gap-2 transition-colors"
          >
            <FontAwesomeIcon icon={faTimes} />
            Limpar Filtros
          </button>
        </div>
      </div>
    </div>
  );
};

export default UsuarioFilterBar;
